import loadable from '@loadable/component';
import { Loader } from '@/components';

export const AsyncPasswordRecovery = loadable(
  () => import('./PasswordRecovery'),
  {
    fallback: <Loader />,
  },
);
